import { combineReducers, configureStore } from "@reduxjs/toolkit";
import homeSwitchSlice from './homeSwitch'

const rootReducers = combineReducers({
  pageSwitch: homeSwitchSlice, 
})
const store = configureStore({
  reducer: rootReducers,
});

export default  store